<script setup>
import {computed} from "vue";
import {getEcoLogo, getLogo} from "@/helpers/logo";
import {getNoun, getNumberWithNoun, joinWithAnd} from "@/helpers/string";

const {need} = defineProps(['need']);

const displayedStartups = computed(() => {
    return need.startups.slice(0, 6);
});
</script>

<template>
    <div>
        <div class="carousel-slide__item">
            <div class="card-needs">
                <div class="card-needs__content">
                    <h5 class="heading5 heading5--secondary">
                        {{need.name}}
                    </h5>

                    <template v-if="need.source === 'ai'">
                        <p>{{ need.startups.length }} new AI {{getNoun('match', need.startups.length, 'matches' )}} </p>

                        <ul class="list-matches">
                            <li v-for="startup in displayedStartups" :key="startup.id">
                                <img :src="getLogo(startup.logo)" alt="" />
                            </li>
                        </ul>
                    </template>

                    <template v-else>
                        <img :src="getEcoLogo(need.ecosystem_logo ?? null)" style="max-height: 50p; max-width: 50px" alt="" />

                        <template v-if="need.ecosystems">
                            <template v-if="need.ecosystems.length === 1">
                                {{ need.ecosystems[0] }} sent you {{getNumberWithNoun('match', need.startups.length, 'matches' )}}
                            </template>
                            <template v-else>
                                Matches from {{joinWithAnd(need.ecosystems)}}
                            </template>
                        </template>
                    </template>
                </div>
                <footer class="card-needs__footer">
                    <a :href="`/needs/${need.id}?openMatchMaking=${need.source}`" target="_blank" class="link-arrow">Review</a>
                </footer>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
